module.exports = __webpack_public_path__ + "media/images/main-background-beach-a26e2cc38178ae3c9ccc1b5c83d50593.jpg";